import * as type from './actionTypes';

export const getAudioGenerationQueueStats = () => ({
  type: type.GET_AUDIO_GENERATION_QUEUE_STATS,
});
export const getAbbreviationsQueueStats = () => ({
  type: type.GET_ABBREVIATIONS_QUEUE_STATS,
});
export const updateAudioGeneration = (action) => ({
  type: type.UPDATE_AUDIO_GENERATION_JOBS,
  action,
});
export const updateAbbreviation = (action) => ({
  type: type.UPDATE_ABBREVIATIONS_JOBS,
  action,
});

export const setAudioGenerationQueueStats = (audioGenerationQueueData) => ({
  type: type.SET_AUDIO_GENERATION_QUEUE_STATS,
  audioGenerationQueueData,
});
export const setAbbreviationsQueueStats = (abbreviationsQueueData) => ({
  type: type.SET_ABBREVIATIONS_QUEUE_STATS,
  abbreviationsQueueData,
});
